exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spec-table[data-v-e0ab5f1e]{\n  width: 100%;\n}\n", ""]);

// exports
